import React from 'react';
import style from './InsiderTrades.module.css';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import usePoliticianTransactions from '../../hooks/usePoliticianTransactions';

const CongressTradesTab = ({ stock, current_user }) => {
  const { politicianTransactions } = usePoliticianTransactions(stock.id);

  if (!politicianTransactions) {
    return null;
  }

  ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

  // create labels for the last 6 quarters
  const labels = [];
  for (let i = 5; i >= 0; i--) {
    const date = new Date();
    date.setMonth(date.getMonth() - i * 3);
    const quarter = Math.floor(date.getMonth() / 3) + 1;
    const year = date.getFullYear();
    labels.push(`Q${quarter} ${year}`);
  }

  const dataSell = [];
  const dataBuy = [];
  for (let i = 5; i >= 0; i--) {
    const date = new Date();
    const month = date.getMonth() - i * 3;
    date.setMonth(month - (month % 3));
    date.setDate(1);

    const politicianTransaction = politicianTransactions.find((politicianTransaction) => {
      const politicianTransactionDate = new Date(politicianTransaction.quarter);
      return (
        politicianTransactionDate.getFullYear() === date.getFullYear() &&
        politicianTransactionDate.getMonth() === date.getMonth() &&
        politicianTransactionDate.getDate() === date.getDate()
      );
    });
    if (politicianTransaction) {
      dataSell.push(politicianTransaction.count_sell);
      dataBuy.push(politicianTransaction.count_buy);
    } else {
      dataSell.push(0);
      dataBuy.push(0);
    }
  }

  const data = {
    labels,
    datasets: [
      {
        label: 'Politicians Sold',
        data: dataSell,
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
        type: 'bar',
      },
      {
        label: 'Politicians Bought',
        data: dataBuy,
        borderColor: 'rgb(53, 162, 235)',
        backgroundColor: 'rgba(60, 157, 14, 0.5)',
        type: 'bar',
      },
    ],
  };
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
      },
      tooltip: {
        intersect: false,
        mode: 'index',
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        display: false,
        grid: {
          display: false,
        },
        ticks: {
          beginAtZero: true,
        },
      },
    },
  };

  return (
    <div>
      {politicianTransactions.length === 0 ?
        <p className={style.noData}>No recent congress trades.</p>
        :
        !current_user || !current_user.active_pro_subscription ? (
          <div className={style.proBanner}>
            <h4>Exclusive for Stockcircle Pro members</h4>
            <a href={current_user ? '/pro' : '/join'} className={style.proLink}>
              <span>Sign up</span>
              <img src="/react/phosphor/caret-right-bold.svg" alt="Sign Up" width="12" height="12" />
            </a>
          </div>
        ) : (
          <div class="utilities__text-center">
            <Bar options={options} data={data} />
            <a href={`/congress-stock-trades?stock=${stock.symbol}`} className={style.link}>View list of trades</a>
          </div>
        )
      }
    </div>
  );
};

export default CongressTradesTab;


